import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/store'; // redux store 구성 모듈
import _ from 'lodash';

import OrganApi from 'src/api/fidp/organApi';
import { OrganEntity, Organutils } from './organ';

// Reducers
export interface RangeOrganState {
  initialized: boolean;
  organs: OrganEntity[];
}

const initialState: RangeOrganState = {
  initialized: false,
  organs: [],
};

export const thunkRangeTree = createAsyncThunk('rangeOrgan/tree', async () => {
  return OrganApi.treeByDept();
});

export const thunkTreeById = createAsyncThunk('rangeOrgan/treeById', async (code: string) => {
  return OrganApi.treeById(code);
});

const rangeOrganSlice = createSlice({
  name: 'rangeOrgan',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(thunkRangeTree.fulfilled, (state, { payload: organ }) => {
      state.organs = organ.map((o) => Organutils.fromOrganDto(o));
      state.initialized = true;
    });
    builder.addCase(thunkTreeById.fulfilled, (state, { payload: organ, meta }) => {
      const key = meta.arg;
      const copyOrgans = _.cloneDeep(state.organs);
      const paramOrgans = organ.map((o) => Organutils.fromOrganDto(o));

      state.organs = recursiveSearchById(copyOrgans, key, paramOrgans);
    });
  },
});

function recursiveSearchById(
  organs: OrganEntity[],
  key: string,
  targetOrgans: OrganEntity[]
): OrganEntity[] {
  organs.forEach((organ) => {
    if (organ.key === key) organ.nodes = targetOrgans;
    else if (organ.nodes.length > 0) {
      organ.nodes = recursiveSearchById(organ.nodes, key, targetOrgans);
    }
  });
  return organs;
}
// # selectors
export const selectInitialized = (state: RootState): boolean => {
  return state.organ.initialized;
};
export const selectRangeOrgans = (state: RootState): OrganEntity[] => state.rangeOrgan.organs;

export default rangeOrganSlice.reducer;
